import { render, staticRenderFns } from "./ApacheChart.vue?vue&type=template&id=38b2ffc8"
import script from "./ApacheChart.vue?vue&type=script&lang=js"
export * from "./ApacheChart.vue?vue&type=script&lang=js"
import style0 from "./ApacheChart.vue?vue&type=style&index=0&id=38b2ffc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports